export default {
  'shortenedUrls.title': 'Gestionar URLs Abreviadas',

  'shortenedUrls.form.entityDisplayName': 'Entidad',
  'shortenedUrls.form.shortenedUrlCode': 'Código URL Abreviada',
  'shortenedUrls.form.entityId': 'Identificador Entidad',
  'shortenedUrls.form.redirectUrl': 'Redireccionar a URL',
  'shortenedUrls.allowedDomains': 'Dominios Permitidos',
};
